import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/system";
import { GridFilterMenuItem, GridColumnPinningMenuItems, SortGridMenuItems, HideGridColMenuItem, } from "@mui/x-data-grid-pro";
import { MenuList } from "@mui/material";
import BryxColors from "../../types/theme";
import { isHideMenuKey, isTabKey } from "./BryxDataGridUtils";
import { forwardRef, useCallback } from "react";
// Based on basic MUI implementation
export const BryxDataGridColumnMenu = styled(forwardRef((props, ref) => {
    const { hideMenu, currentColumn, open, id, labelledby, className, children, ...other } = props;
    const handleListKeyDown = useCallback((event) => {
        if (isTabKey(event.key)) {
            event.preventDefault();
        }
        if (isHideMenuKey(event.key)) {
            hideMenu(event);
        }
    }, [hideMenu]);
    return (_jsxs(MenuList, { id: id, ref: ref, className: className, "aria-labelledby": labelledby, onKeyDown: handleListKeyDown, autoFocus: open, sx: { marginTop: "-8px" }, ...other, children: [_jsx(GridFilterMenuItem, { onClick: hideMenu, column: currentColumn }), _jsx(GridColumnPinningMenuItems, { onClick: hideMenu, column: currentColumn }), _jsx(SortGridMenuItems, { onClick: hideMenu, column: currentColumn }), _jsx(HideGridColMenuItem, { onClick: hideMenu, column: currentColumn })] }));
}))(({ theme }) => ({
    "& *": {
        fontSize: "13px",
        color: BryxColors.notify(theme.palette.mode, "inactive"),
    },
}));
export default BryxDataGridColumnMenu;
